export default {
  data: {
    type: Array,
    default: () => ([])
  },
  title: {
    type: String,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/preview/resources/props.js